import React from 'react';
import { Button } from 'primereact/button';

/**
 * Presentational content for the "confirm before delete/update a document" toast
 * used by useUpdateVehicleAcceptanceForm.js. Previously this markup was authored
 * inline as a `content` render-prop directly inside the hook (a hook returning
 * JSX is an anti-pattern); it now lives in its own component and the hook just
 * passes data + callbacks.
 */
const DocumentActionConfirmToastContent = ({ summary, detail, cancelLabel = 'İptal', confirmLabel, confirmSeverity = 'danger', onCancel, onConfirm }) => (
    <div className="flex flex-column align-items-start" style={{ flex: '1' }}>
        <div className="flex align-items-center gap-2">
            <span className="font-bold text-900">{summary}</span>
        </div>
        <div className="font-medium text-lg my-3 text-900">{detail}</div>
        <div className="flex gap-2">
            <Button label={cancelLabel} onClick={onCancel} className="p-button-sm" severity="secondary" />
            <Button label={confirmLabel} onClick={onConfirm} className="p-button-sm" severity={confirmSeverity} />
        </div>
    </div>
);

export default DocumentActionConfirmToastContent;
